import { Separator, Text, VStack } from '@chakra-ui/react';
import { ScrollArea } from '@components/ui/ScrollArea';
import { FormattedMessage } from 'react-intl';

import { RoleEnum } from '@/types/authent/roles.types';

import RoleSubCategory from './RoleSubCategory';

type Props = {
  name: string;
  category: Record<string, RoleEnum[]>;
  skipTranslation?: boolean;
};

export default function RoleCategory({ name, category, skipTranslation = false }: Readonly<Props>) {
  return (
    <ScrollArea width="100%">
      <VStack width="760px" marginX="auto" paddingY={8} key={name} gap={0} flex={1}>
        <Text textStyle="xl" marginBottom={5}>
          <FormattedMessage id={`components.usersManagement.profiles.roles.category.${name}`} />
        </Text>
        <Separator size="md" borderColor="neutral.800" />
        <VStack width="100%" gap={0} separator={<Separator size="md" borderColor="neutral.800" />}>
          {Object.entries(category).map(([name, list]) => (
            <RoleSubCategory
              key={name}
              subCategoryName={name}
              subCategoryList={list}
              skipTranslation={skipTranslation}
            />
          ))}
        </VStack>
        <Separator size="md" borderColor="neutral.800" />
      </VStack>
    </ScrollArea>
  );
}
